<template>
  <div class="patient-card">
    <promised :promise="promise" :pending-delay="0" v-if="!hasError">
      <template #pending>
        <patient-card-widget-skeleton></patient-card-widget-skeleton>
      </template>
      <template #default="{ data }">
          <div>
            <div class="patient-card__row">
              <p>Name</p>
              <div class="patient-card__spacer"></div>
              <p>{{ $helpers.mask('patient_name', data.patient.display_name) }}</p>
            </div>
            <div class="patient-card__row">
              <p>Room #</p>
              <div class="patient-card__spacer"></div>
              <p>{{ data.room?.name || ' ' }}</p>
            </div>
            <div class="patient-card__row">
              <p>Age</p>
              <div class="patient-card__spacer"></div>
              <p>{{ data.patient.dob ? age(data.patient.dob) : 'N/A' }}</p>
            </div>
            <div class="patient-card__row">
              <p>Sex</p>
              <div class="patient-card__spacer"></div>
              <p>{{ data.patient.gender }}</p>
            </div>
            <div class="patient-card__row">
              <p>Pronoun</p>
              <div class="patient-card__spacer"></div>
              <p>{{ data.patient.pronoun || ' ' }}</p>
            </div>
            <div class="patient-card__row">
              <p>Language</p>
              <div class="patient-card__spacer"></div>
              <p>{{ data.patient.language ?  data.patient.language.name : ' ' }}</p>
            </div>
          </div>
      </template>
      <template v-slot:rejected="error">
        <p>Error: {{ error.message }}</p>
      </template>
    </promised>
    <div v-else class="widget-permission-error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import PatientCardWidgetSkeleton from "@/components/skeletons/PatientCardWidgetSkeleton";
import WidgetMixin from "@/components/mixins/WidgetMixin";
import GenericWidgetGuard from "@/components/permissions/GenericWidgetGuard";

export default {
  name: "PatientCardWidget",
  mixins: [WidgetMixin],
  components: {PatientCardWidgetSkeleton},
  widget: {
    serviceMethod: 'getMonitors',
    title: 'Patient Card',
    guard: GenericWidgetGuard
  },
  methods: {
    age(dob) {
      return this.$helpers.getDate().diff(dob, 'years')
    }
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.patient-card {
  display: flex;
  flex-direction: column;
}
.patient-card__row {
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    color: $main-text-color;
    margin: 0;
  }
  &:not(:last-child) {
    margin-bottom: 15px;
  }
}
.patient-card__spacer {
  flex: 1;
  height: 1px;
  background-image: linear-gradient(to right, $main-text-color 10%, rgba(255, 255, 255, 0) 0%);
  background-position: top;
  background-size: 10px 1px;
  background-repeat: repeat-x;
  margin: 0 10px;
}
</style>
